import React from "react";

export default function FooterTitle({ title }) {
  return (
    <h3 className="">
      <div>{title}</div>
      <div className="mt-2.5 bg-secondary flex-1 h-0.5 max-w-[73px]"></div>
    </h3>
  );
}
